import { Pipe, PipeTransform } from '@angular/core';
import { valueSearch } from '../models/product.model';

@Pipe({
  name: 'highlightSKU'
})
export class HighlightSKUPipe implements PipeTransform {

  transform(text: string, search: valueSearch): string {
    if (!search || !search.value) { return text; }
    if(search.option === 'SKU'){
      let pattern = search.value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern.split(' ').filter((t) => {
        return t.length > 0;
      }).join('|');
      const regex = new RegExp(pattern, 'gi');
      return search ? text.replace(regex, (match) => `<span class="highlight">${match}</span>`) : text;
    } else {
      return text;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipe/highlightSKU.pipe.ts